import { Controller } from "@hotwired/stimulus";
import { setMultipleEmailsValidator } from "../utils/parsley_validators_utils";

export default class extends Controller {
  initialize() {
    setMultipleEmailsValidator();
  }
}
